<template>
  <div class="logManagement">
     <keep-alive :include="cachedViews">
      <router-view :key="key"/>
    </keep-alive>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'logManagement',
  data() {
    return {};
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
    ...mapGetters({
      cachedViews: 'tags/cachedViews'
    })
  }
};
</script>
<style lang="scss" scoped>
</style>
